import { render, staticRenderFns } from "./adjustment-dialog.vue?vue&type=template&id=0064b927&scoped=true&"
import script from "./adjustment-dialog.vue?vue&type=script&lang=js&"
export * from "./adjustment-dialog.vue?vue&type=script&lang=js&"
import style0 from "./adjustment-dialog.vue?vue&type=style&index=0&id=0064b927&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0064b927",
  null
  
)

export default component.exports